import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar (進度條)
import 'nprogress/nprogress.css' // progress bar style (進度條樣式)
import { getToken } from '@/utils/auth' // get token from cookie
import { ElNotification } from 'element-plus'
NProgress.configure({
  showSpinner: false
})

router.beforeEach(async (to, from, next) => {
  try {
    NProgress.start()
    if (to.meta.title) {
      document.title = to.meta.title
    }

    const hostUrl = window.location.href.split('/')[2]
    await store.dispatch('user/getBrandSiteInfo', hostUrl)

    const hasToken = getToken()
    if (hasToken) {
      handleAuthenticatedUser(to, next)
    } else {
      handleUnauthenticatedUser(to, next)
    }
  } catch (error) {
    console.error('Error during navigation:', error)
    ElNotification({
      title: 'Navigation Error',
      message: error.message || 'An error occurred while navigating',
      type: 'error',
      duration: 2000,
    });
    next(false)
  } finally {
    NProgress.done()
  }
})

function handleAuthenticatedUser(to, next) {
  const loginPages = [
    '/login', '/sign-up',
    '/forget-password/email-idv',
    '/forget-password/mobile-idv'
  ]
  if (loginPages.includes(to.path)) {
    const path = window.innerWidth >= 576 ? '/member/calendar' : '/member'
    next({ path })
    return
  }
  try {
    next()
  } catch (error) {
    ElNotification({
      title: error || 'Has Error',
      type: 'error',
      duration: 2000
    })
  }
}

function handleUnauthenticatedUser(to, next) {
  if (!to.meta.needLogin) {
    next()
    return
  }
  const { path, query } = to
  let redirectQuery = { redirect: path }
  if (Object.hasOwn(query, 'from')) {
    redirectQuery.from = query.from
  } else if (Object.hasOwn(query, 'date')) {
    redirectQuery = {
      ...redirectQuery,
      date: query.date,
      courtId: query.courtId,
      startTime: query.startTime,
      price: query.price
    }
  }
  next({
    path: '/login',
    query: redirectQuery
  })
}